// extracted by mini-css-extract-plugin
export default {"header":"index_header_-lIIn","stickyTop":"index_stickyTop_Pqg-h","headerBox":"index_headerBox_-R-q7","logo":"index_logo_zENgY","botton":"index_botton_-B9Vf"};